export const LOGIN_TO_MY_WINDSOR = 27
export const VIEW_CUSTOMERS_LIST = 29
export const SELECT_METRIC_TYPES = 30
export const EXPORT_CUSTOMERS_LIST = 31
export const VIEW_CUSTOMERS_METRICS = 32
export const VIEW_CUSTOMERS_CHARTS = 33
export const RECALCULATE_METRICS = 36
export const VIEW_CUSTOMER = 37
export const VIEW_CUSTOMER_CONTACTS_LIST = 38
export const EXPORT_CUSTOMER_CONTACTS_LIST = 39
export const VIEW_CUSTOMER_ACTIVITIES_LIST = 40
export const EXPORT_CUSTOMER_ACTIVITIES_LIST = 41
export const VIEW_CUSTOMER_USER_LOGS_LIST = 42
export const EXPORT_CUSTOMER_USER_LOGS_LIST = 43
export const VIEW_CUSTOMER_CONTRACTS_LIST = 44
export const EXPORT_CUSTOMER_CONTRACTS_LIST = 45
export const VIEW_CUSTOMER_INVOICES_LIST = 47
export const EXPORT_CUSTOMER_INVOICES_LIST = 48
export const DOWNLOAD_CUSTOMER_BILLING_FILES = 49
export const VIEW_CUSTOMER_CANCELLATIONS_LIST = 50
export const EXPORT_CUSTOMER_CANCELLATIONS_LIST = 51
export const VIEW_CUSTOMER_PRODUCTS_LIST = 53
export const EXPORT_CUSTOMER_PRODUCTS_LIST = 54
export const VIEW_CUSTOMER_BUNDLES_LIST = 58
export const EXPORT_CUSTOMER_BUNDLES_LIST = 59
export const VIEW_CUSTOMER_TARIFFS_LIST = 60
export const EXPORT_CUSTOMER_TARIFFS_LIST = 61
export const VIEW_CUSTOMER_AUTHENTICATION = 95
export const CREATE_CUSTOMER_AUTHENTICATION = 96
export const DELETE_CUSTOMER_AUTHENTICATION = 97
export const VIEW_CUSTOMER_SUBACCOUNTS_LIST = 106
export const EXPORT_CUSTOMER_SUBACCOUNTS_LIST = 107
export const MANAGE_CUSTOMER_SUBACCOUNT_SSO= 108
export const MANAGE_CUSTOMER_SERVICES= 110
export const MANAGE_CUSTOMER_PROPERTIES= 111